import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "../../lib/api";
import { Shell } from "./_shell";

const EMPTY_REVIEW = { name: "", text: "", display_order: 0 };

export default function Reviews() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(EMPTY_REVIEW);
  const [editId, setEditId] = useState(null);
  const load = () => api.get("/reviews").then(r => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name || !form.text) { toast.error("Name and review text are required"); return; }
    try {
      const payload = { ...form, display_order: parseInt(form.display_order) || 0 };
      if (editId) await api.put(`/reviews/${editId}`, payload);
      else await api.post("/reviews", payload);
      toast.success(editId ? "Review updated" : "Review added");
      setForm(EMPTY_REVIEW); setEditId(null); load();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  const remove = async (r) => {
    if (!window.confirm("Delete this review?")) return;
    try { await api.delete(`/reviews/${r.id}`); toast.success("Deleted"); load(); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <Shell active="reviews">
      <div className="p-5 md:p-10 max-w-3xl">
        <div className="overline mb-2">Homepage testimonials</div>
        <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-8">Reviews.</h1>
        <div className="border border-ink hard-shadow p-5 mb-8 bg-paper" data-testid="review-form">
          <div className="overline mb-4">{editId ? "Edit review" : "New review"}</div>
          <div className="space-y-4">
            <div>
              <label className="overline block mb-2">Customer name</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Priya P. — Convenience Store, Toronto" className="field" data-testid="rf-name" />
            </div>
            <div>
              <label className="overline block mb-2">Review text</label>
              <textarea rows={3} value={form.text} onChange={e => setForm({ ...form, text: e.target.value })} className="field" data-testid="rf-text" />
            </div>
            <div>
              <label className="overline block mb-2">Sort order</label>
              <input type="number" value={form.display_order} onChange={e => setForm({ ...form, display_order: e.target.value })} className="field max-w-[120px]" data-testid="rf-order" />
              <div className="text-[10px] text-black/50 mt-1">Lower numbers appear first.</div>
            </div>
          </div>
          <div className="mt-4 flex gap-2">
            <button onClick={save} className="btn-primary" data-testid="rf-save">{editId ? "Save changes" : "Add review"}</button>
            {editId && <button onClick={() => { setEditId(null); setForm(EMPTY_REVIEW); }} className="btn-ghost">Cancel</button>}
          </div>
        </div>
        <div className="space-y-3" data-testid="reviews-list">
          {list.map(r => (
            <div key={r.id} className="border border-ink p-5 bg-paper" data-testid={`admin-review-${r.id}`}>
              <div className="flex justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-bold">{r.name}</div>
                  <p className="text-sm text-black/70 mt-1 italic">"{r.text}"</p>
                </div>
                <div className="flex gap-3 shrink-0">
                  <button onClick={() => { setEditId(r.id); setForm({ name: r.name, text: r.text, display_order: r.display_order }); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="text-xs underline" data-testid={`review-edit-${r.id}`}>Edit</button>
                  <button onClick={() => remove(r)} className="text-xs underline text-soda" data-testid={`review-delete-${r.id}`}>Delete</button>
                </div>
              </div>
            </div>
          ))}
          {list.length === 0 && <div className="border border-ink p-8 text-center text-black/50">No reviews yet.</div>}
        </div>
      </div>
    </Shell>
  );
}
